import api from "./api";
import { API_ENDPOINTS } from "./endpoints";
import { User, UpdateUserBody, UserFormValues, UserStatusBody } from "../types/user";
import { ListResponse, Params } from "../types";

// API tìm user theo email chữ thường khi đăng nhập, nên email phải được lưu ở dạng này
const normalizeEmail = (email: string) => email.trim().toLowerCase();

const userService = {
  async getUserList(params: Params): Promise<ListResponse<User>> {
    try {
      const response = await api.get(API_ENDPOINTS.USERS.LIST, { params });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async createUser(body: UserFormValues): Promise<void> {
    try {
      await api.post(API_ENDPOINTS.USERS.CREATE, {
        ...body,
        email: normalizeEmail(body.email),
      });
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateUser(id: number, values: UserFormValues): Promise<void> {
    try {
      // Ô mật khẩu để trống = giữ mật khẩu cũ
      const { password, ...rest } = values;
      const body: UpdateUserBody = {
        ...rest,
        email: normalizeEmail(rest.email),
        ...(password ? { newPassword: password } : {}),
      };
      await api.patch(API_ENDPOINTS.USERS.UPDATE(id), body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateUserStatus(id: number, body: UserStatusBody): Promise<void> {
    try {
      await api.patch(API_ENDPOINTS.USERS.UPDATE_STATUS(id), body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },
  
};

export default userService;